import type { ProductListingResource, ProductVariantResource, OrderItemWithStock } from '@storefront/resources';

export function viewItemListEvent(items: ProductListingResource[], currency: string) {
  let mapped = items.map((item) => {
    return {
      item_name: item.title,
      item_id: item.id,
      price: Number(Number(item.priceGross).toFixed(2)),
      quantity: 1,
      ...(item.type !== 'FLEXIBLE' && {
        discount: calculateItemDiscount(item),
      }),
    };
  });

  return {
    'event': 'view_item_list',
    'ecommerce': {
      'currency': currency,
      'items': mapped,
    },
  };
}


export function viewItemEvent(item: ProductVariantResource, currency: string) {
  return {
    'event': 'view_item',
    'ecommerce': {
      'currency': currency,
      'value': calculateItemTotalPrice(item),
      'items': [{
        item_name: item.title,
        item_id: item.productId,
        quantity: 1,
        price: Number(Number(item.priceGross).toFixed(2)),
        ...(item.type !== 'FLEXIBLE' && {
          discount: calculateItemDiscount(item),
        }),
      }],
    },
  };
}

export function selectItemEvent(item: ProductListingResource | OrderItemWithStock, currency: string) {
  return {
    'event': 'select_item',
    'ecommerce': {
      'currency': currency,
      'items': [{
        'item_name': getItemName(item),
        'item_id': item.id,
        price: Number(Number(item.priceGross).toFixed(2)),
        quantity: 1,
        ...(getItemType(item) !== 'FLEXIBLE' && {
          discount: calculateItemDiscount(item),
        }),
      }],
    },
  };
}

function calculateItemDiscount(item: ProductListingResource | ProductVariantResource | OrderItemWithStock): number {
  if (item.regularGross === null) {
    return 0;
  }

  const regularGross = Number(item.regularGross);
  const priceGross = Number(item.priceGross);

  return Number((regularGross - priceGross).toFixed(2));
}

function calculateItemTotalPrice(item: ProductVariantResource): number {
  const stock = 1;

  return Number((Number(item.priceGross) * stock).toFixed(2));
}

function getItemName(
  item: ProductListingResource | OrderItemWithStock,
): string | null {
  if ('title' in item) {
    // ProductListingResource
    return item.title;
  }

  // OrderItemWithStock
  return item.variantTitle;
}

function getItemType(
  item: ProductListingResource | OrderItemWithStock,
): string | null {
  if ('type' in item) {
    // ProductListingResource
    return item.type;
  }

  // OrderItemWithStock
  return item.productType;
}
